import { Box, Card, Typography, useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { CustomButton } from '../../../../v2/MUI_custom_component';
import { InsuranceType } from '../../../../v2/Benefits/Beneficiary/constants';

const AnnualBenefitCard = ({ item }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery('(max-width: 1200px)');

  const handleAnnualTripViewDetailsClick = () => {
    navigate('/annual-trip');
  };

  const handleTreePlantationViewDetailsClick = () => {
    navigate('/tree-plantation');
  };

  return (
    <Card
      sx={{
        boxShadow: 'none',
        position: 'relative',
        ...(item?.action_button?.show
          ? {
              p: 2,
              borderRadius: 2,
            }
          : {
              backgroundColor: 'transparent',
            }),
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box
            component='img'
            src={item?.logo_url}
            sx={{
              height: 'auto',
              width: { xs: '48px', sm: '64px' }, // mobile vs desktop
            }}
          />
          <Box sx={{}}>
            <Typography variant='h2'>{item?.name}</Typography>
            <Typography
              variant='body1'
              sx={{ color: '#666' }}
            >
              {item?.description}
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            position: 'absolute',
            right: { xs: '15px', md: '20px' },
            top: { xs: '5px', md: '10px' },
          }}
        >
          <Typography
            variant='labelS'
            sx={{ color: item?.status?.color }}
          >
            {item?.status?.label}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
        {item?.action_button?.show &&
          item?.value === InsuranceType.ANNUAL_TOUR && (
            <CustomButton
              onClick={handleAnnualTripViewDetailsClick}
              variant='outlined'
              color='primary'
              size={isMobile ? 'small' : 'medium'}
              label={item?.action_button?.label}
            />
          )}
           {item?.action_button?.show &&
          item?.value === InsuranceType.TREE_PLANTATION && (
            <CustomButton
              onClick={handleTreePlantationViewDetailsClick}
              variant='outlined'
              color='primary'
              size={isMobile ? 'small' : 'medium'}
              label={item?.action_button?.label}
            />
          )}
      </Box>
    </Card>
  );
};

export default AnnualBenefitCard;
